//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { memo } from "react";
import { X } from "lucide-react";
import { EmailChipProps } from './types';

const EmailChip = memo<EmailChipProps>(({ email, onRemove }) => (
  <div
    className={tw`inline-flex items-center gap-1 bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm mr-1 mb-1`}
  >
    <span>{email}</span>
    <button
      type="button"
      onClick={() => onRemove(email)}
      className={tw`hover:bg-blue-200 rounded-full p-0.5 transition-colors`}
      aria-label={`Remove ${email}`}
    >
      <X size={15} />
    </button>
  </div>
));

EmailChip.displayName = "EmailChip";

export { EmailChip };